const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8081/api';

function getToken(): string {
  return localStorage.getItem('token') || '';
}

export interface WorkerTaskItem {
  message_id: string;
  task_type: string;
  project_id: string;
  project_name: string;
  status: 'pending' | 'running';
  created_at: string;
  idle_time_ms: number;
  consumer: string;
}

export interface PollTaskGroup {
  pending_count: number;
  running_count: number;
  tasks: Record<string, unknown>[];
}

export interface ProviderConcurrencyItem {
  key: string;
  name: string;
  in_flight: number;
  limit: number; // 0 = 不限
}

export interface TaskOverviewResp {
  summary: {
    total_pending: number;
    total_running: number;
  };
  worker_tasks: {
    pending_count: number;
    running_count: number;
    tasks: WorkerTaskItem[];
  };
  poll_tasks: Record<string, PollTaskGroup>;
  provider_concurrency: ProviderConcurrencyItem[];
}

export async function fetchTaskOverview(): Promise<TaskOverviewResp> {
  const token = getToken();
  const response = await fetch(`${API_BASE}/admin/tasks/overview`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (response.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
    throw new Error('未登录');
  }
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || 'Request failed');
  }
  return response.json();
}
